

const asci = (asci) => {
    if (asci)
        return String.fromCodePoint(parseInt(asci, 16))
    return ''
}

export { asci }